export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResidenciaProfesionalDescargasPage.vue?vue&type=template&id=83fb5458&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/ResidenciaProfesionalDescargasPage.vue?vue&type=template&id=83fb5458&scoped=true&
// module id = 638
// module chunks = 17